// "use strict";

const navbarBookmark = document.querySelector("[data-js='navbar-bookmark']");
const navbarContact = document.querySelector("[data-js='navbar-contact']");
const navbarLanguage = document.querySelector("[data-js='navbar-language']");

if (navbarBookmark) {
	if (window.innerWidth > 991) {
		$("[data-toggle='popover']").popover({placement: "bottom", offset: "0, 0",});
		$("[data-toggle='popover']").on("show.bs.popover", function () {
			// $("#modal-backdrop").addClass("modal-backdrop show");
			$("[data-toggle='popover']").not(this).popover("hide");
		});
		$("[data-toggle='popover']").on("hide.bs.popover", function () {
			setTimeout(function () {
				if (!$(".popover").hasClass("show")) {
					$("#modal-backdrop").removeClass("modal-backdrop show");
				}
			}, 50)
		});

	} else {
		$("[data-toggle='popover']").popover({placement: "top", offset: "0, 30px",});

		$("[data-toggle='popover']").on("show.bs.popover", function () {
			$("#modal-backdrop").addClass("modal-backdrop show");
			$("[data-toggle='popover']").not(this).popover("hide");
		});

		$("[data-toggle='popover']").on("hide.bs.popover", function () {
			setTimeout(function () {
				if (!$(".popover").hasClass("show")) {
					$("#modal-backdrop").removeClass("modal-backdrop show");
				}
			}, 50)
		});
	}

	$("#modal-backdrop").on("click", function () {
		$("[data-toggle='popover']").popover("hide");
		$("#modal-backdrop").removeClass("modal-backdrop show");
	});

	$(navbarBookmark).on("show.bs.popover", function () {
		if (window.innerWidth > 991) {
			$(this).find("source").attr("srcset", "/assets/img/svg/icon-merkliste-ausgewaehlt-desktop.svg");
		} else {
			$(this).find("img").attr("src", "/assets/img/svg/icon-merkliste-ausgewaehlt-mobile.svg");
		}
	});

	$(navbarBookmark).on("hide.bs.popover", function () {
		if (window.innerWidth > 991) {
			$(this).find("source").attr("srcset", "/assets/img/svg/icon-merkliste-leer-desktop.svg");
		} else {
			$(this).find("img").attr("src", "/assets/img/svg/icon-merkliste-leer-mobile.svg");
		}
	});

	$(navbarContact).on("show.bs.popover", function () {
		$(document).on("click", ".chat-start", function () {
			$("#m-chat").modal("show");
			$('#chat-welcome').delay(5000).fadeOut(600);
		});
		if (window.innerWidth > 991) {
			$(this).find("source").attr("srcset", "/assets/img/svg/icon-kontakt-ausgewaehlt-desktop.svg");
		} else {
			$(this).find("img").attr("src", "/assets/img/svg/icon-kontakt-ausgewaehlt-mobile.svg");
		}
	});

	$(navbarContact).on("hide.bs.popover", function () {
		if (window.innerWidth > 991) {
			$(this).find("source").attr("srcset", "/assets/img/svg/icon-kontakt-desktop.svg");
		} else {
			$(this).find("img").attr("src", "/assets/img/svg/icon-kontakt-mobile.svg");
		}
	});

	$(navbarLanguage).on("show.bs.popover", function () {
		$(document).on("click", ".chat-start", function () {
			$("#m-chat").modal("show");
			$('#chat-welcome').delay(5000).fadeOut(600);
		});
		if (window.innerWidth > 991) {
			$(this).find("source").attr("srcset", "/assets/img/svg/icon-sprache-ausgewaehlt-desktop.svg");
		} else {
			$(this).find("img").attr("src", "/assets/img/svg/icon-sprache-mobile-ausgewaehlt.svg");
		}
	});

	$(navbarLanguage).on("hide.bs.popover", function () {
		if (window.innerWidth > 991) {
			$(this).find("source").attr("srcset", "/assets/img/svg/icon-sprache-desktop.svg");
		} else {
			$(this).find("img").attr("src", "/assets/img/svg/icon-sprache-mobile.svg");
		}
	});

}